<template>
    <div class="odgovor-single" @click="select" v-bind:class="{'odgovor-single': true, 'answer-disabled': !this.canClick}">
        <div class="checkbox" v-bind:class="{'checkbox': true, 'active': this.answer.index == value}"></div>
        <div class="odgovor img-odgovor" v-if="answer.imgValue">
            <img :src="answer.imgValue"/>
        </div>
        <div class="odgovor" v-else-if="answer.value">
            <p>{{ answer.value }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'probni-odgovor-single',
    props: ['answer', 'value', 'canClick'],
    methods: {
        select () {
            if (this.canClick) {
                this.$emit('input', this.answer.index)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.odgovor-single {
    clear: both;
    position: relative;
    width: 100%;
    cursor: pointer;
    &:hover p {
        color: #3d85ce;
    }
    p {
        transition: color .4s ease-in-out;
        margin-bottom: 16px;
    }
    .checkbox {
        width: 21px;
        height: 21px;
        background-image: url(~@/assets/img/icons/checkbox.png);
        background-position: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        float: left;
        margin-right: 5px;
        &.active {
            background-image: url(~@/assets/img/icons/checkbox-checked.png);
        }
    }
    &.answer-disabled {
        color: #999;
    }
}
</style>
